import get from "lodash/get"
import {
  StripePriceFragment,
  StripeProductFragment,
  StripeProductsQueryHookResult,
  StripeProductsQueryVariables,
  useStripeProductsQuery
} from "../../api/generated"
import { flattenEdges } from "../../utils/apollo"

export type StripeProduct = StripeProductFragment & {
  stripe_prices: StripePriceFragment[]
}

export default function useStripeProducts(
  variables: Omit<StripeProductsQueryVariables, "first"> = {}
): [StripeProduct[], StripeProductsQueryHookResult] {
  const query = useStripeProductsQuery({
    variables: { first: 50, ...variables }
  })
  const stripeProducts = flattenEdges(get(query, "data.stripeProducts")) || []
  return [stripeProducts, query]
}
